import TagManager from 'react-gtm-module';

/**
 * push de data to GTM
 * */
export default function pushDataLayer(data){
    TagManager.dataLayer({dataLayer: data });
}

